import { cheminFiche, cheminFlux, cheminRubrique, cheminTraduit, urlAbsolue } from './chemins.js';
import { estDisponible, texte } from './contract/index.js';
import { libelles } from './i18n.js';
import { rubriqueDeLaVue } from './vues.js';
const ORDRE_ETATS = {
    'en-cours': 0,
    'a-venir': 1,
    passee: 2,
};
function index(elements) {
    return new Map(elements.map((element) => [element.slug, element]));
}
export function creerContexte(siteData, langue, chemin, vue) {
    const l = libelles(langue);
    const oeuvres = siteData.oeuvres.filter((o) => o.visible);
    const expositions = siteData.expositions.filter((e) => e.type === 'exposition');
    const foires = siteData.expositions.filter((e) => e.type === 'foire');
    const actualites = siteData.actualites
        .slice()
        .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
    const parSlugOeuvre = index(oeuvres);
    const parSlugArtiste = index(siteData.artistes);
    const parSlugExposition = index(siteData.expositions);
    const parSlugActualite = index(siteData.actualites);
    const t = (valeur) => texte(valeur, langue);
    const rubriquePubliee = (rubrique) => {
        if (rubrique === 'oeuvres')
            return siteData.options.oeuvresDisponibles;
        if (rubrique === 'foires')
            return foires.length > 0;
        return true;
    };
    const trierExpositions = (liste) => liste.slice().sort((a, b) => {
        const ecart = ORDRE_ETATS[a.etat] - ORDRE_ETATS[b.etat];
        if (ecart !== 0)
            return ecart;
        return a.etat === 'passee'
            ? b.dateDebut.localeCompare(a.dateDebut)
            : a.dateDebut.localeCompare(b.dateDebut);
    });
    const rubriqueDe = (exposition) => exposition.type === 'foire' ? 'foires' : 'expositions';
    return {
        siteData,
        langue,
        chemin,
        vue,
        l,
        t,
        tf: (valeur) => (valeur === undefined ? undefined : t(valeur)),
        oeuvres,
        oeuvresDisponibles: oeuvres.filter(estDisponible),
        artistes: siteData.artistes,
        expositions: trierExpositions(expositions),
        foires: trierExpositions(foires),
        actualites,
        artiste: (slug) => parSlugArtiste.get(slug),
        oeuvre: (slug) => parSlugOeuvre.get(slug),
        exposition: (slug) => parSlugExposition.get(slug),
        actualite: (slug) => parSlugActualite.get(slug),
        oeuvresDeLArtiste: (artiste) => artiste.oeuvres
            .map((slug) => parSlugOeuvre.get(slug))
            .filter((o) => o !== undefined),
        expositionsDeLArtiste: (artiste) => trierExpositions(artiste.expositions
            .map((slug) => parSlugExposition.get(slug))
            .filter((e) => e !== undefined)),
        oeuvresDeLExposition: (exposition) => exposition.oeuvres
            .map((slug) => parSlugOeuvre.get(slug))
            .filter((o) => o !== undefined),
        artistesDeLExposition: (exposition) => exposition.artistes
            .map((slug) => parSlugArtiste.get(slug))
            .filter((a) => a !== undefined),
        parEtat: (type, etat) => trierExpositions(siteData.expositions.filter((e) => e.type === type && e.etat === etat)),
        expositionEnCours: () => expositions.find((e) => e.etat === 'en-cours') ??
            siteData.expositions.find((e) => e.etat === 'en-cours'),
        agenda: (limite) => trierExpositions(siteData.expositions.filter((e) => e.etat !== 'passee')).slice(0, limite),
        rubriquePubliee,
        lienRubrique: (rubrique) => cheminRubrique(langue, rubrique),
        lienFiche: (rubrique, slug) => cheminFiche(langue, rubrique, slug),
        lienArtiste: (artiste) => cheminFiche(langue, 'artistes', artiste.slug),
        lienOeuvre: (oeuvre) => cheminFiche(langue, 'oeuvres', oeuvre.slug),
        lienExposition: (exposition) => cheminFiche(langue, rubriqueDe(exposition), exposition.slug),
        lienActualite: (actualite) => cheminFiche(langue, 'actualites', actualite.slug),
        lienFlux: () => cheminFlux(langue),
        lienLangue: (autre) => {
            if (!siteData.galerie.langues.actives.includes(autre))
                return undefined;
            const cible = rubriqueDeLaVue(vue);
            if (cible === undefined)
                return cheminRubrique(autre, 'accueil');
            if (!rubriquePubliee(cible.rubrique))
                return cheminRubrique(autre, 'accueil');
            return cheminTraduit(cible.rubrique, cible.slug, autre);
        },
        absolu: (c) => urlAbsolue(siteData.galerie.domaine, c),
    };
}
//# sourceMappingURL=contexte.js.map